/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';

import { PostNavigationMenu, PurpleColor } from './PostNavigation.styled';

const PostNavigation = ({ goToFeed, goToAssignments, style, prevPage }) => {
  const action = prevPage === 'all assignments' ? goToAssignments : goToFeed;

  return (
    <PostNavigationMenu style={style} onClick={action}>
      <ChevronLeft color={PurpleColor} style={{ marginBottom: '-7px' }} />
      <span>Back to {prevPage}</span>
    </PostNavigationMenu>
  );
};

PostNavigation.propTypes = {
  goToFeed: PropTypes.func.isRequired,
  goToAssignments: PropTypes.func.isRequired,
  style: PropTypes.object,
  prevPage: PropTypes.string,
};

PostNavigation.defaultProps = {
  style: {},
  prevPage: 'feed',
};

export default PostNavigation;
